
export class TypePoiResponseDto {
  id: number;
  nom: string;
  pointInterests: PoiInterestShortResponse[];
  imageUri: string;
  color: string;
  constructor(id?:number){
    this.id = id;
  }
}

export interface PoiInterestShortResponse {
  idPointInterest: number;
  name: string;
  coordinate: { lat: number; lng: number };
}

export class TypePoiRequestDto {
  id: number;
  nom: string=' ';
  imageUri: string;
  color: string;
  pointInterestsIds: number[];

  public constructor(color?:string ,nom?:string,imageUri?:string,pointInterestsIds?: number[]){
    this.color = color
    this.nom = nom;
    this.imageUri = imageUri
    this.pointInterestsIds = pointInterestsIds

  }

}
